var version = require('../package.json').version;

const createScript = (url) => {
  return new Promise((resolve, reject) => {
    let script = document.createElement('script');
    script.setAttribute('src', url);
    script.setAttribute('type', 'text/javascript');
    document.body.appendChild(script);
    script.onload = (res) => {
      resolve(res);
    };
    script.onerror = (error) => {
      reject(error);
    };
  });
};

const createCss = (url) => {
  return new Promise((resolve, reject) => {
    let link = document.createElement('link');
    link.setAttribute('href', url);
    link.setAttribute('type', 'text/css');
    link.setAttribute('rel', 'stylesheet');
    document.body.appendChild(link);
    link.onload = (res) => {
      resolve(res);
    };
    link.onerror = (error) => {
      reject(error);
    };
  });
};

export const getComp = () => {
  return Promise.all([
    // 引入此js非接触点餐页引入图片可动态修改
    createScript('https://awp-assets.meituan.net/hfe/fep/f8461749385341599660f25328f5f3c5.js'),
    createScript(`/component-web/static/comp/${version}/index.js`),
    createCss(`/component-web/static/comp/${version}/index.css`)
  ]).then((res) => {
    return true;
  }).catch(() => {
    return false;
  });
};







// WEBPACK FOOTER //
// ./src/start.js